// extracted by mini-css-extract-plugin
module.exports = {"list":"_39SgX","item":"_7DgJ2","normal":"eqtbU","link":"BhUnz","text":"XWKtZ"};